<template>
  <div class="page">
    <h2 class="accent--text">
      <v-icon color="primary" class="ml-3" large>mdi-cogs</v-icon>
      إعدادات عامة
      <back-button />
    </h2>
    <hr class="mt-5 mb-8 header-divider" />

    <live class="mb-10" />
    <sponsor />
  </div>
</template>

<script>
import Live from './Settings/Live';
import Sponsor from './Settings/Sponsor';

export default {
  name: 'settings',
  components: { Live, Sponsor }
}
</script>
